module.exports = __webpack_public_path__ + "static/google-product-title-optimization-2fefd7ce3ec9f78718ba5a45057c2ba0.jpg";